import Widgets from 'ext:fof/forum-widgets-core/common/extend/Widgets';
import UbuntuReleaseCountdownWidget from './components/UbuntuReleaseCountdownWidget';
export default function registerWidget(app) {
  new Widgets().add({
    key: 'ubhuUbuntuReleaseCountdown',
    component: UbuntuReleaseCountdownWidget,
    title: 'Release Counter',
    displayName: 'Release Counter',
    isDisabled: false,
    isUnique: true,
    placement: 'end',
    position: 1
  }).extend(app, 'ubhu-ubuntu-release-countdown-widget');
}
flarum.reg.add('ubhu-ubuntu-release-countdown-widget', 'common/registerWidget', registerWidget);